import type {RutaProd} from '../../../../runtime/rutas';
export default {
  "ruta": "/sistema/registro",
  "alias": [],
  "documento": "raiz",
  "acceso": "publico",
  "filas": [
    "155"
  ],
  "cita": "Controllers/AccountController.cs"
} satisfies RutaProd;
